import React from 'react';
import { Upload } from 'lucide-react';

const Sidebar = ({ activeSection, onSectionChange, showUploadInputs, setShowUploadInputs }) => (
  <div className="w-1/4 p-4 bg-gray-100 flex flex-col">
    <button
      onClick={() => onSectionChange('faq')}
      className={`w-full p-2 mb-2 rounded ${activeSection === 'faq' ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
    >
      FAQs
    </button>
    <button
      onClick={() => onSectionChange('utterance')}
      className={`w-full p-2 mb-2 rounded ${activeSection === 'utterance' ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
    >
      Utterances
    </button>
    <button
      onClick={() => onSectionChange('answer')}
      className={`w-full p-2 mb-2 rounded ${activeSection === 'answer' ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
    >
      Answers
    </button>
    <div className="mt-auto">
      <button
        onClick={() => setShowUploadInputs(!showUploadInputs)}
        className="w-full p-2 mb-2 rounded bg-green-500 text-white flex items-center justify-center"
      >
        <Upload size={18} className="mr-2" />
        Mass Upload
      </button>
    </div>
  </div>
);

export default Sidebar;